import { render, staticRenderFns } from "./BaseRegistrationForBusinessUserStepTwo.vue?vue&type=template&id=9c0c5a8c&"
import script from "./BaseRegistrationForBusinessUserStepTwo.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForBusinessUserStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./BaseRegistrationForBusinessUserStepTwo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports